import { useTranslation } from "react-i18next"
import { BellSlash } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { NewsFragment$data } from "@/modules/admin/news/services/__generated__/NewsFragment.graphql"

interface ShowingNewsProps {
  dataNews: NewsFragment$data
  onStopNews: (data: NewsFragment$data) => void
}

const ShowingNews = ({ dataNews, onStopNews }: ShowingNewsProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-row">
      <div className="ml-[25%] grow border-l">
        <Button
          className="hover:bg-surface-hovered focus-visible:bg-surface-focused active:bg-surface-pressed text-critical ml-[10%] flex bg-transparent"
          onClick={(e) => {
            e.stopPropagation()
            onStopNews(dataNews)
          }}>
          <BellSlash size={24} />
          {t("admin.news.stopShowingNow")}
        </Button>
      </div>
    </div>
  )
}

export { ShowingNews }
